import { useEffect } from "react";
import config from "../../config";

const CHATBOT_CONTAINER_ID = 'chatbot-container';

export default function ChatBot() {
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = config.chatbotCSS;
        document.head.insertBefore(link, document.head.firstChild);

        const script = document.createElement('script');
        script.src = config.chatbotJS;
        script.defer = true;
        script.onload = () => {
            window.renderChatBot({
                apiKey: config.apiKey,
                siteID: config.siteID,
                baseURL: config.baseURL,
                rootID: CHATBOT_CONTAINER_ID,
                accessToken: config.accessToken,
                language: 'en',
                title: config.chatbotTitle,
                isDarkMode: false,
                shouldAutoOpen: false,
            });
        };
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
            document.head.removeChild(link);
        };
    }, []);

    return <div id={CHATBOT_CONTAINER_ID} />;
}
